import {ETHNICITY_TYPES} from "@/store";

export default {
  watch: {
    ethnicity: function (newVal, oldVal) {
      newVal = Array.isArray(newVal) ? newVal : [newVal];
      oldVal = Array.isArray(oldVal) ? oldVal : [oldVal];
      const isOldNA = (oldVal ||[]).some(v => v === ETHNICITY_TYPES.NA);
      const isNewNA = (newVal ||[]).some(v => v === ETHNICITY_TYPES.NA);

      if (isOldNA && newVal.length > 1) {
        const indexNA = this.ethnicity.findIndex(v => v === ETHNICITY_TYPES.NA);
        this.$delete(this.ethnicity, indexNA);
      } else if (!isOldNA && isNewNA) {
        let ind = 0;
        while (this.ethnicity.length > 1) {
          if (this.ethnicity[ind] === ETHNICITY_TYPES.NA) {
            ind++;
          } else {
            this.$delete(this.ethnicity, ind);
          }
        }
      }
    }
  }
};
